export const typeDefs = `
  union ArticleType = announcements | news | promotions | tutorials | system

  union ArticlesGroup = bronze | silver | gold | user | video
`;
